import { render, staticRenderFns } from "./homeworkDetails.vue?vue&type=template&id=184fdf56&scoped=true"
import script from "./homeworkDetails.vue?vue&type=script&lang=js"
export * from "./homeworkDetails.vue?vue&type=script&lang=js"
import style0 from "./homeworkDetails.vue?vue&type=style&index=0&id=184fdf56&prod&lang=scss&scoped=true"
import style1 from "./homeworkDetails.vue?vue&type=style&index=1&id=184fdf56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fdf56",
  null
  
)

export default component.exports